// extracted by mini-css-extract-plugin
export default {"form":"CustomTypeFilter_form__cgdLJ","grid":"CustomTypeFilter_grid__EulJC","footer":"CustomTypeFilter_footer__402Yr"};